/*  JS to reset cookie banner on click 'Gestion des cookies' link (footer)
    Added by Wilson from Galadrim  */

// Cookie banner reset
(() => {
  const COOKIE = "_tracking_consent";

  /* deletes the two possible variants of the cookie */
  function clearTrackingConsent() {
    /* without domain */
    document.cookie = COOKIE + "=; Max-Age=0; Path=/; SameSite=Lax";

    /* with second-level domain */
    const root = location.hostname.replace(/^www\./, "");
    document.cookie = COOKIE + "=; Max-Age=0; Path=/; Domain=" + root + "; SameSite=Lax";
  }

  function handler(e) {
    const link = e.target.closest('a[href$="#cookies-preferences"]');
    if (!link) return;

    e.preventDefault();
    e.stopImmediatePropagation(); // on court‑circuit InstantPage / Turbo

    clearTrackingConsent();

    const url = location.pathname + location.search + (location.search ? "&" : "?") + "cookies-reset=" + Date.now();
    location.assign(url);
  }

  document.addEventListener("pointerdown", handler, true);
  document.addEventListener("click", handler, true);
})();
